<ion-content class="bg-color ion-content update-user">
  <div class="com-content">
    <div class="content-breadcrumb">
      <ul class="breadcrumb">
        <li *ngFor="let itemList of breadcrumbList" class="breadcrumb-item">
          <ng-container *ngIf="itemList.embedurl; else noRoute">
            <a href="javascript:void(0)" routerLink="{{ itemList.url }}">
              {{ itemList.label }}
            </a>
          </ng-container>
          <ng-template #noRoute>
            <a href="javascript:void(0)" (click)="goBack()">
              {{ itemList.label }}
            </a>
          </ng-template>
        </li>
      </ul>
    </div>
    <div class="content-grid">
      <div class="m-content">
        <mat-card>
          <mat-card-title class="mc-title">
            <span class="org-header">Group Filter</span>
          </mat-card-title>
          <mat-card-content class="mc-content">
            <div class="form-container">
              <form [formGroup]="updateGroupFilterForm" (ngSubmit)="onSubmit()">
                <div class="form-layout">
                  <mat-form-field appearance="outline">
                    <mat-label>Index Name</mat-label>
                    <input type="text" formControlName="indexName" matInput placeholder="Index Name"
                      (keydown.enter)="$event.preventDefault()" required>
                    <mat-error *ngIf="setUserControls.indexName.hasError('required')">
                      Index Name Required.
                    </mat-error>
                    <mat-error *ngIf="setUserControls.indexName.hasError('noSpace')">
                      Index Name should not contain whitespace.
                    </mat-error>
                    
                    <mat-error *ngIf="setUserControls.indexName.hasError('invalidCharacters')">
                      Only letters, numbers,underscores (_) and and hyphen (-) are allowed.
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field appearance="outline">
                    <mat-label>Column Name</mat-label>
                    <input type="text" formControlName="columnName" matInput placeholder="Column Name"
                      (keydown.enter)="$event.preventDefault()" required >
                    <mat-error *ngIf="setUserControls.columnName.hasError('required')">Column Name Required.
                    </mat-error>
                  </mat-form-field>
                </div>
                
                <div class="form-layout">
                  <mat-form-field appearance="outline">
                    <mat-label>Condition</mat-label>
                    <mat-select formControlName="conditionFlag" 
                      (selectionChange)="getConditionSelected($event)">
                      <mat-option *ngFor="let condition of conditionList" [value]="condition.value" selected>{{condition.label}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field appearance="outline">
                    <mat-label>Data Type</mat-label>
                    <mat-select formControlName="columnDataType" 
                      (selectionChange)="getDataTypeSelected($event)">
                      <mat-option *ngFor="let dataType of dataTypeList" [value]="dataType" selected>{{dataType}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                   <ng-container [ngSwitch]="selectedDataType">
    
                    <!-- Text Area for "Text" -->
                    <mat-form-field *ngSwitchCase="'Text'" appearance="outline">
                      <mat-label>Value</mat-label>
                      <textarea matInput formControlName="columnValue" placeholder="Enter text here..."></textarea>
                      <mat-error *ngIf="updateGroupFilterForm.controls.columnValue.hasError('required')">
                        Value is required.
                      </mat-error>
                      <mat-error *ngIf="updateGroupFilterForm.controls.columnValue.hasError('maxlength')">
                        Maximum length is 255 characters.
                      </mat-error>
                    </mat-form-field>
                
                    <!-- Date Picker for "Date" -->
                    <mat-form-field *ngSwitchCase="'Date'" appearance="outline">
                      <input 
                        matInput 
                        [ngxMatDatetimePicker]="pickerCustomIcon"
                        formControlName="columnValue" 
                        placeholder="YYYY-MM-DD HH:mm:ss"
                        [disabled]="false">

                      <ngx-mat-datepicker-toggle matSuffix [for]="pickerCustomIcon"></ngx-mat-datepicker-toggle>
                      <ngx-mat-datetime-picker 
                        #pickerCustomIcon 
                        [showSpinners]="true" 
                        [showSeconds]="true"
                        [touchUi]="false"
                        [enableMeridian]="true"
                        [stepHour]="1" [stepMinute]="1" [stepSecond]="1">
                        <ngx-mat-datepicker-actions>
                          <button mat-button ngxMatDatepickerCancel>Cancel</button>
                          <button mat-raised-button color="primary" ngxMatDatepickerApply>Apply</button>
                        </ngx-mat-datepicker-actions>
                    </ngx-mat-datetime-picker>
                    <mat-error *ngIf="updateGroupFilterForm.controls.columnValue.hasError('required')">
                      Value is required.
                    </mat-error>
                      <mat-error *ngIf="updateGroupFilterForm.controls.columnValue.hasError('invalidISODate')">
                        Date must be in YYYY-MM-DDTHH:MM:SSZ format.
                      </mat-error>
                    </mat-form-field>
                
                    <!-- Input Field for "Long" -->
                    <mat-form-field *ngSwitchCase="'Long'" appearance="outline">
                      <mat-label>Value</mat-label>
                      <input type="text" matInput formControlName="columnValue" placeholder="Enter an Numbers">
                      <mat-error *ngIf="updateGroupFilterForm.controls.columnValue.hasError('required')">
                        Value is required.
                      </mat-error>
                      <mat-error *ngIf="updateGroupFilterForm.controls.columnValue.hasError('pattern')">
                        Only numbers are allowed for "Long".
                      </mat-error>
                    </mat-form-field>
                
                    <!-- Input Field for "Binary" -->
                    <mat-form-field *ngSwitchCase="'Binary'" appearance="outline">
                      <mat-label>Value</mat-label>
                      <textarea type="text" matInput formControlName="columnValue" placeholder="Enter a string eg.U29tZSBiaW5hcnkgZGF0YQ=="></textarea>
                      <mat-error *ngIf="updateGroupFilterForm.controls.columnValue.hasError('required')">
                        Value is required.
                      </mat-error>
                      <mat-error *ngIf="updateGroupFilterForm.controls.columnValue.hasError('invalidBase64')">
                        Invalid binary format.
                      </mat-error>
                    </mat-form-field>
                
                    <!-- Input Field for "Vector" -->
                    <mat-form-field *ngSwitchCase="'Vector'" appearance="outline">
                      <mat-label>Value</mat-label>
                      <input type="text" matInput formControlName="columnValue" placeholder="Enter a Value (e.g., 0.12, -0.45, 0.67)">
                      <mat-error *ngIf="updateGroupFilterForm.controls.columnValue.hasError('required')">
                        Value is required.
                      </mat-error>
                      <mat-error *ngIf="updateGroupFilterForm.controls.columnValue.hasError('invalidVector')">
                        Invalid vector format.
                      </mat-error>
                    </mat-form-field>

                     <!-- Number Input for "Float" -->
                    <mat-form-field *ngSwitchCase="'Float'" appearance="outline">
                      <mat-label>Value</mat-label>
                      <input type="text" matInput step="0.0001" formControlName="columnValue" placeholder="Enter a float number (eg.3.14, -1.23e-4)">
                      <mat-error *ngIf="updateGroupFilterForm.controls.columnValue.hasError('required')">
                        Value is required.
                      </mat-error>
                      <mat-error *ngIf="updateGroupFilterForm.controls.columnValue.hasError('invalidFloat')">
                        Invalid Float format.
                      </mat-error>
                    </mat-form-field>
                      
                  <!-- Number Input for "Boolean" -->
                    <mat-form-field *ngSwitchCase="'Boolean'" appearance="outline">
                      <mat-label>Value</mat-label>
                      <mat-select formControlName="columnValue">
                        <mat-option [value]="true">True</mat-option>
                        <mat-option [value]="false">False</mat-option>
                      </mat-select>
                      <mat-error *ngIf="updateGroupFilterForm.controls.columnValue.hasError('required')">
                        Please select a value.
                      </mat-error>
                    </mat-form-field>
                  
                    <!-- Number Input for "Byte" (-128 to 127) -->
                    <mat-form-field *ngSwitchCase="'Byte'" appearance="outline">
                      <mat-label>Value</mat-label>
                      <input type="text" matInput formControlName="columnValue" placeholder="Enter a value (-128 to 127)">
                      <mat-error *ngIf="updateGroupFilterForm.controls.columnValue.hasError('required')">
                        Value is required.
                      </mat-error>
                      <mat-error *ngIf="updateGroupFilterForm.controls.columnValue.hasError('invalidByte')">
                        Invalid Byte format.
                      </mat-error>
                    </mat-form-field>
                  
                    <!-- Number Input for "Double" -->
                    <mat-form-field *ngSwitchCase="'Double'" appearance="outline">
                      <mat-label>Value</mat-label>
                      <input type="text" matInput formControlName="columnValue" placeholder="Enter a double number (eg.3.14159265358979)">
                      <mat-error *ngIf="updateGroupFilterForm.controls.columnValue.hasError('required')">
                        Value is required.
                      </mat-error>
                      <mat-error *ngIf="updateGroupFilterForm.controls.columnValue.hasError('invalidDouble')">
                        Invalid Double format.
                      </mat-error>
                    </mat-form-field>

                    <!-- Number Input for "Integer" -->
                  <mat-form-field *ngSwitchCase="'Integer'" appearance="outline">
                    <mat-label>Value</mat-label>
                    <input type="text" matInput formControlName="columnValue" placeholder="Enter an integer (eg.-2147483648,2147483647)">
                    <mat-error *ngIf="updateGroupFilterForm.controls.columnValue.hasError('required')">
                      Value is required.
                    </mat-error>
                    <mat-error *ngIf="updateGroupFilterForm.controls.columnValue.hasError('invalidInteger')">
                      Invalid Integer format.
                    </mat-error>
                  </mat-form-field>
                   
                  
                    <!-- Number Input for "short integer " -->
                  <mat-form-field *ngSwitchCase="'Short Integer'" appearance="outline">
                    <mat-label>Value</mat-label>
                    <input type="text" matInput formControlName="columnValue" placeholder="Enter a short integer (-32,768 to 32,767)">
                    <mat-error *ngIf="updateGroupFilterForm.controls.columnValue.hasError('required')">
                      Value is required.
                    </mat-error>
                    <mat-error *ngIf="updateGroupFilterForm.controls.columnValue.hasError('invalidShortInteger')">
                      Invalid  Short Integer format.
                    </mat-error>
                  </mat-form-field>

                  </ng-container>
                  
                 
                  
                </div>

                <div class="btn-signup-grid">
                  <button mat-raised-button class="btn" (click)="goToGroupFilterList()">Cancel</button>
                  <button mat-raised-button type="submit" class="btn btn-signup">Update</button>
                </div>
              </form>
            </div>
          </mat-card-content>
        </mat-card>
      </div>

      <app-about-page *ngIf="hide1200"></app-about-page>
    </div>
    <app-footer></app-footer>
  </div>
</ion-content>